/* eslint-disable no-case-declarations */
/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import _ from 'lodash';
import metadata from './MLHOBusinessScheduleItemsComponent.metadata.json5';
import messages from './MLHOBusinessScheduleItemsComponent.messages';
import appConfig from 'app-config';
import styles from './MLHOBusinessScheduleItemsComponent.module.scss';
import { useTranslator } from '@jutro/locale';

const BUSINESS_PURSUITS_TYPE = 'businessPursuits';

// Used for HO Business Pursuits and HO Incidental Business Within Home
function MLHOBusinessScheduleItemsComponent(props) {
    const {
        items,
        defaultItem,
        schedItemType,
        readOnly,
        loading,
        parentRemoveItemHandler,
        resetChosenTermAndChosenTermValue,
        formatOptionAvailableVals,
        onCovChange
    } = props;

    const isQnB = appConfig.portalCode === 'QB';
    const translator = useTranslator();

    const isBusinessPursuits = schedItemType === BUSINESS_PURSUITS_TYPE;

    const getDefaultScheduleItem = useCallback(() => {
        const defaultBusinessItem = resetChosenTermAndChosenTermValue(defaultItem);
        return _.omit(defaultBusinessItem, ['fixedId']);
    }, [defaultItem, resetChosenTermAndChosenTermValue]);

    const onAddItem = useCallback(() => {
        const defaultItemVal = getDefaultScheduleItem();
        items.push(defaultItemVal);
        onCovChange(undefined, undefined, undefined, true);
    }, [getDefaultScheduleItem, items, onCovChange]);

    const onRemoveItem = useCallback((evt) => {
        parentRemoveItemHandler(evt.index, schedItemType);
    }, [parentRemoveItemHandler, schedItemType]);

    const dropdownChanged = useCallback((selectedOption, item) => {
        item.chosenTerm = selectedOption;
        item.updated = true;
        onCovChange(undefined,undefined,undefined,true);
    }, [onCovChange]);

    const generateItemOverrides = useCallback(() => {
        const itemOverrides = items.map((item, itemIndex) => {
            return {
                [`actionRow${itemIndex}`]: {
                    visible: !readOnly,
                    className: loading ? 'cell disabled' : 'cell'
                },
                // Business Class
                [`businessClassRow${itemIndex}`]: {
                    visible: isBusinessPursuits
                },
                [`businessClassSelectDiv${itemIndex}`]: {
                    visible: !readOnly && isBusinessPursuits,
                    className: isQnB ? 'businessClassStyle' : 'select'
                },
                [`businessClassDropdown${itemIndex}`]: {
                    visible: isBusinessPursuits,
                    value: item.businessClass && item.businessClass.chosenTerm,
                    availableValues: formatOptionAvailableVals(_.get(item, 'businessClass.options', [])),
                    disabled: loading,
                    path: item.businessClass,
                    onValueChange: dropdownChanged,
                    label: isQnB ? translator(messages.businessClass) : '',
                    labelClassName : isQnB ? 'businessLabelStyle' : ''
                },
                [`businessClassReadonlyMobileSpan${itemIndex}`]: {
                    visible: readOnly && isBusinessPursuits
                },
                [`businessClassReadOnlyContent${itemIndex}`]: {
                    visible: readOnly && isBusinessPursuits
                },
                // Item Class
                [`itemClassRow${itemIndex}`]: {
                    visible: !isBusinessPursuits
                },
                [`itemClassSelectDiv${itemIndex}`]: {
                    visible: !readOnly && !isBusinessPursuits,
                    className: isQnB ? 'itemClassStyle' : 'select'
                },
                [`itemClassDropdown${itemIndex}`]: {
                    visible: !isBusinessPursuits,
                    value: item.itemClass && item.itemClass.chosenTerm,
                    availableValues: formatOptionAvailableVals(_.get(item, 'itemClass.options', [])),
                    disabled: loading,
                    path: item.itemClass,
                    onValueChange: dropdownChanged,
                    label: isQnB ? translator(messages.businessClass) : '',
                    labelClassName : isQnB ? 'businessLabelStyle' : ''
                },
                [`itemClassReadonlyMobileSpan${itemIndex}`]: {
                    visible: readOnly && !isBusinessPursuits
                },
                [`itemClassReadOnlyContent${itemIndex}`]: {
                    visible: readOnly && !isBusinessPursuits
                },
                // Business Sub Class
                [`businessSubClassSelectDiv${itemIndex}`]: {
                    visible: !readOnly,
                    className: isQnB ? 'businessSubClassStyle' : 'select'
                },
                [`businessSubClassDropdown${itemIndex}`]: {
                    value: item.subClass && item.subClass.chosenTerm,
                    availableValues: formatOptionAvailableVals(_.get(item, 'subClass.options', [])),
                    disabled: loading,
                    path: item.subClass,
                    onValueChange: dropdownChanged,
                    label: isQnB ? translator(messages.businessSubClass) : '',
                    labelClassName : isQnB ? 'businessLabelStyle' : ''
                },
                [`businessSubClassReadonlyMobileSpan${itemIndex}`]: {
                    visible: readOnly
                },
                [`businessSubClassReadOnlyContent${itemIndex}`]: {
                    visible: readOnly
                }
            };
        });

        return Object.assign({}, ...itemOverrides);
    }, [dropdownChanged, formatOptionAvailableVals, isBusinessPursuits, items, loading, readOnly]);

    const overrides = {
        stackTableDiv: {
            className: readOnly ? 'stack-table' : 'stack-table plain'
        },
        actionHeader: {
            visible: !readOnly
        },
        tableRowIterable: {
            data: items
        },
        bottomButtonContainer: {
            visible: !readOnly
        },
        addItemBtn: {
            visible: !readOnly,
            disabled: loading
        },
        ...generateItemOverrides()
    };


    const resolvers = {
        resolveCallbackMap: {
            onAddItem,
            onRemoveItem
        },
        resolveClassNameMap: styles
    };

    return (
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrides}
            {...resolvers} />
    );
}

MLHOBusinessScheduleItemsComponent.propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({})),
    schedItemType: PropTypes.string,
    defaultItem: PropTypes.shape({}),
    readOnly: PropTypes.bool,
    loading: PropTypes.bool,
    parentRemoveItemHandler: PropTypes.func,
    resetChosenTermAndChosenTermValue: PropTypes.func,
    onCovChange: PropTypes.func
};

export default MLHOBusinessScheduleItemsComponent;
